/**
 * Bar
 * This is a loading bar component with optional caption and minimum value
 */
import { createStyles, makeStyles } from '@material-ui/core';
import React from 'react';
import { Typography } from '../..';
const Bar = ({ filled, minimum, caption, className, color }) => {
    const useStyles = makeStyles((theme) => createStyles({
        outerContainer: {
            width: '100%',
        },
        innerContainer: {
            background: theme.palette.divider,
            height: theme.spacing(2),
            borderRadius: 5,
            overflow: 'hidden',
        },
        minimum: {
            background: theme.palette.background.paper,
            width: 3,
            height: theme.spacing(2),
            marginLeft: `${minimum}%`,
            position: 'relative',
            zIndex: 100,
            top: theme.spacing(-2),
        },
        bar: {
            background: color || theme.palette.secondary.dark,
            width: `${filled}%`,
            height: '100%',
        },
    }));
    const classes = useStyles();
    return (React.createElement("div", { className: className || classes.outerContainer },
        React.createElement("div", { className: classes.innerContainer },
            React.createElement("div", { className: classes.bar }),
            minimum && React.createElement("div", { className: classes.minimum })),
        React.createElement(Typography, { variant: "caption", color: "textSecondary", fontWeight: "light" }, caption)));
};
export { Bar };
//# sourceMappingURL=Bar.js.map